import React from 'react'
import { MuiTextfield, MuiDatePicker } from 'material-ui-elements'
import _ from 'lodash'
import core from '../../core'

import { valueTable as commonConfigValues } from './commonConfig'

const {
  helpers: {
    keepInLength,
    calculateFlag,
    calculateFrequencyDate,
    getLoginFromMail,
    getUserId
  },
  constants: { DATE_FORMAT }
} = core

const {
  theirRole,
  decision,
  trainingFrequency,
  nationalities
} = commonConfigValues

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const qualificationTypes = [
  { id: 1, label: 'Nursing' },
  { id: 2, label: 'Psychology' },
  { id: 3, label: 'Social Care' },
  { id: 4, label: 'Social Work' },
  { id: 5, label: 'Teaching' },
  { id: 6, label: 'Youth & Community' },
  { id: 7, label: 'Other' }
]

export const valueTable = { qualificationTypes }

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'personnel.ui',
      'personnel.fullName',
      'vetting.vettingFlag',
      'qualification.title',
      'qualification.type',
      'registration.body',
      'registration.flag',
      'cv.cvOnFile',
      'reference.onFile',
      'drive.number',
      'drive.approvedToOwnCar',
      'drive.approvedToCarCompany',
      'drive.flag'
    ]
  }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.ui',
    title: 'Staff Member Personel No. (UI)',
    minSpace: 'Personel No. (UI) ',
    formField: true
  },
  {
    name: 'register.firstName',
    title: 'SM First Name',
    hidden: true,
    minSpace: 'SM ',
    formField: true
  },
  {
    name: 'register.lastName',
    title: 'SM Last Name',
    hidden: true,
    minSpace: 'SM ',
    formField: true
  },
  {
    name: 'register.fullName',
    title: 'Staff Member Name',
    formField: true,
    getCellValue: row =>
      `${row['register.firstName'] || ''} ${row['register.lastName'] || ''}`,
    maxChars: 100,
    minSpace: 'Staff Member '
  },
  {
    name: 'vetting.vettingDate',
    title: 'Garda Vetting Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Garda Vetting '
  },
  {
    name: 'vetting.vettingOnFile',
    title: 'Garda Vetting on File?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`vetting.vettingOnFile`], 10)])
        ? _.find(decision, ['id', parseInt(row[`vetting.vettingOnFile`], 10)])
            .label
        : row[`vetting.vettingOnFile`],
    options: 'decision',
    filterField: true,
    minSpace: 'Garda Vetting '
  },
  {
    name: 'vetting.gardaValidity',
    title: 'Current Garda Vetting Validity Period ',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(trainingFrequency, [
        'id',
        parseInt(row[`vetting.gardaValidity`], 10)
      ])
        ? _.find(trainingFrequency, [
            'id',
            parseInt(row[`vetting.gardaValidity`], 10)
          ]).label
        : row[`vetting.gardaValidity`],
    options: 'trainingFrequency',
    filterField: true,
    minSpace: 'Current Garda Vetting '
  },
  {
    //auto calculated
    name: 'vetting.expiryDate',
    title: 'Garda Vetting Expiry Date',
    formField: true,
    type: 'date',
    // getCellValue: row =>
    // filterField: true,
    minSpace: 'Garda Vetting '
  },
  {
    //auto calculated
    name: 'vetting.vettingFlag',
    title: 'Garda Vetting Flag',
    formField: true,
    // getCellValue: row =>
    filterField: true,
    minSpace: 'Garda Vetting '
  },
  {
    name: 'vetting.vettingCountry',
    title: 'International Police Vetting Country(s)',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`vetting.vettingCountry`], 10)])
        ? _.find(decision, ['id', parseInt(row[`vetting.vettingCountry`], 10)])
            .label
        : row[`vetting.vettingCountry`],
    options: 'decision',
    filterField: true,
    minSpace: 'International Police '
  },
  {
    name: 'vetting.policeVettingDate',
    title: 'International Police Vetting Date(s)',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'International Police '
  },
  {
    name: 'vetting.reportOnFile',
    title: 'International Police Vetting Report(s) on File? ',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`vetting.reportOnFile`], 10)])
        ? _.find(decision, ['id', parseInt(row[`vetting.reportOnFile`], 10)])
            .label
        : row[`vetting.reportOnFile`],
    options: 'decision',
    filterField: true,
    minSpace: 'Vetting Report(s) on File '
  },

  {
    name: 'qualification.type',
    title: 'Professional Qualification Type(s)',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(qualificationTypes, [
        'id',
        parseInt(row[`qualification.type`], 10)
      ])
        ? _.find(qualificationTypes, [
            'id',
            parseInt(row[`qualification.type`], 10)
          ]).label
        : row[`qualification.type`],
    options: 'qualificationTypes',
    filterField: true,
    minSpace: 'Professional Qualification '
  },
  {
    name: 'qualification.title',
    title: 'Qualification Title(s)',
    formField: true,
    // filterField: true,
    minSpace: 'Qualification '
  },
  {
    name: 'qualification.awarding',
    title: 'Awarding University / College(s)',
    formField: true,
    // filterField: true,
    minSpace: 'University / College(s) '
  },
  {
    name: 'qualification.date',
    title: 'Qualification Date(s)',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Qualification '
  },
  {
    name: 'qualification.onFile',
    title: 'Qualification Transcripts(s) on File?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`qualification.onFile`], 10)])
        ? _.find(decision, ['id', parseInt(row[`qualification.onFile`], 10)])
            .label
        : row[`qualification.onFile`],
    options: 'decision',
    filterField: true,
    minSpace: 'Transcripts(s) on File '
  },
  {
    name: 'registration.body',
    title: 'Professional Registration Body Name',
    formField: true,
    // filterField: true,
    minSpace: 'Professional Registration '
  },
  {
    name: 'registration.no',
    title: 'Professional Registration No.',
    formField: true,
    // filterField: true,
    minSpace: 'Registration No. '
  },
  {
    name: 'registration.date',
    title: 'Professional Registration Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Registration Date '
  },
  {
    name: 'registration.expiryDate',
    title: 'Professional Registation Expiry Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Registration Expiry Date '
  },
  {
    //auto calculated
    name: 'registration.flag',
    title: 'Professional Registration Flag',
    formField: true,
    // getCellValue: row =>
    filterField: true,
    minSpace: 'Registration Flag '
  },

  {
    name: 'cv.date',
    title: 'Curriculum Vitae Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Curriculum Vitae '
  },
  {
    name: 'cv.checkedDate',
    title: 'Curriculum Vitae Checked Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Curriculum Vitae '
  },
  {
    name: 'cv.checkByName',
    title: 'Curriculum Vitae Check By Name',
    formField: true,
    type: 'select',
    // getCellValue: row =>
    //   _.find(this.data.register, ['id', parseInt(row[`cv.checkByName`], 10)])
    //     ? _.find(this.data.register, [
    //         'id',
    //         parseInt(row[`cv.checkByName`], 10)
    //       ]).firstName
    //     : row[`cv.checkByName`],
    options: 'register',
    filterField: true,
    minSpace: 'Curriculum Vitae '
  },
  {
    //AUTO CALCULATED BASED ON SUPERVISOR
    name: 'cv.theirRole',
    title: 'Their Role',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, ['id', parseInt(row[`cv.theirRole`], 10)])
        ? _.find(theirRole, ['id', parseInt(row[`cv.theirRole`], 10)]).label
        : row[`cv.theirRole`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Their Role '
  },
  {
    name: 'cv.cvOnFile',
    title: 'Curriculum Vitae on File? ',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`cv.cvOnFile`], 10)])
        ? _.find(decision, ['id', parseInt(row[`cv.cvOnFile`], 10)]).label
        : row[`cv.cvOnFile`],
    options: 'decision',
    filterField: true,
    minSpace: 'Curriculum Vitae on '
  },

  {
    name: 'reference.date',
    title: 'Reference Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Reference '
  },
  {
    name: 'reference.checkedDate',
    title: 'Reference Checked Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Reference Checked Date '
  },
  {
    name: 'reference.checkByName',
    title: 'Reference Checked By Name',
    formField: true,
    type: 'select',
    // getCellValue: row =>
    //   _.find(users, ['id', parseInt(row[`reference.checkByName`], 10)])
    //     ? _.find(users, ['id', parseInt(row[`reference.checkByName`], 10)]).label
    //     : row[`reference.checkByName`],
    options: 'users',
    filterField: true,
    minSpace: 'Checked By Name '
  },
  {
    //AUTO CALCULATED BASED ON SUPERVISOR
    name: 'reference.theirRole',
    title: 'Their Role',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, ['id', parseInt(row[`reference.theirRole`], 10)])
        ? _.find(theirRole, ['id', parseInt(row[`reference.theirRole`], 10)])
            .label
        : row[`reference.theirRole`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Their Role '
  },
  {
    name: 'reference.onFile',
    title: 'References on File?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`reference.onFile`], 10)])
        ? _.find(decision, ['id', parseInt(row[`reference.onFile`], 10)]).label
        : row[`reference.onFile`],
    options: 'decision',
    filterField: true,
    minSpace: 'References on '
  },

  {
    //auto calculated
    name: 'drive.number',
    title: 'Driving Licence Number',
    formField: true,
    // getCellValue: row =>
    filterField: true,
    minSpace: 'Driving Licence '
  },
  {
    name: 'drive.endorsments',
    title: 'Endorsements?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`drive.endorsments`], 10)])
        ? _.find(decision, ['id', parseInt(row[`drive.endorsments`], 10)]).label
        : row[`drive.endorsments`],
    options: 'decision',
    filterField: true,
    minSpace: 'Endorsements? '
  },
  {
    //auto calculated
    name: 'drive.points',
    title: 'No. of Penalty Points',
    formField: true,
    // getCellValue: row =>
    filterField: true,
    minSpace: 'No. of Penalty '
  },
  {
    name: 'drive.licenseOnFile',
    title: 'Driving Licence on File?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`drive.licenseOnFile`], 10)])
        ? _.find(decision, ['id', parseInt(row[`drive.licenseOnFile`], 10)])
            .label
        : row[`drive.licenseOnFile`],
    options: 'decision',
    filterField: true,
    minSpace: 'Driving Licence on '
  },
  {
    name: 'drive.approvedToOwnCar',
    title: 'Approved to Drive Own Car?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`drive.approvedToOwnCar`], 10)])
        ? _.find(decision, ['id', parseInt(row[`drive.approvedToOwnCar`], 10)])
            .label
        : row[`drive.approvedToOwnCar`],
    options: 'decision',
    filterField: true,
    minSpace: 'Approved to Drive '
  },

  {
    name: 'drive.indemnityOnFile',
    title: 'Own Car Insurance incl. Indemnity on File? ',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`drive.indemnityOnFile`], 10)])
        ? _.find(decision, ['id', parseInt(row[`drive.indemnityOnFile`], 10)])
            .label
        : row[`drive.indemnityOnFile`],
    options: 'decision',
    filterField: true,
    minSpace: 'Own Car Insurance incl. '
  },
  {
    name: 'drive.nctOnFile',
    title: 'Own Car NCT on File?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`drive.nctOnFile`], 10)])
        ? _.find(decision, ['id', parseInt(row[`drive.nctOnFile`], 10)]).label
        : row[`drive.nctOnFile`],
    options: 'decision',
    filterField: true,
    minSpace: 'Own Car NCT on '
  },
  {
    name: 'drive.approvedToCarCompany',
    title: 'Approved to Drive Company car?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`drive.approvedToCarCompany`], 10)])
        ? _.find(decision, [
            'id',
            parseInt(row[`drive.approvedToCarCompany`], 10)
          ]).label
        : row[`drive.approvedToCarCompany`],
    options: 'decision',
    filterField: true,
    minSpace: 'Approved to Drive '
  },
  {
    name: 'drive.approvalDate',
    title: 'Approval Granted Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Granted Date '
  },
  {
    name: 'drive.grantedByName',
    title: 'Approval Granted by Name',
    formField: true,
    type: 'select',
    // getCellValue: row =>
    //   _.find(users, ['id', parseInt(row[`drive.grantedByName`], 10)])
    //     ? _.find(users, ['id', parseInt(row[`drive.grantedByName`], 10)]).label
    //     : row[`drive.grantedByName`],
    options: 'users',
    filterField: true,
    minSpace: 'Granted by Name '
  },
  {
    //AUTO CALCULATED BASED ON SUPERVISOR
    name: 'drive.theirRole',
    title: 'Their Role',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, ['id', parseInt(row[`drive.theirRole`], 10)])
        ? _.find(theirRole, ['id', parseInt(row[`drive.theirRole`], 10)]).label
        : row[`drive.theirRole`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Their Role '
  },
  {
    name: 'drive.approvalReviewDate',
    title: 'Driving Approval Review Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Approval Review Date '
  },
  {
    //auto calculated
    name: 'drive.flag',
    title: 'Driving Approval Flag',
    formField: true,
    // getCellValue: row =>
    filterField: true,
    minSpace: 'Driving Approval '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues,
  activeFormName
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'vetting',
      historyName: 'vettingHistory',
      label: 'Personnel',
      icon: 'note',
      fields: [
        {
          //DISABLED FOR LEVEL 1
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Personnel Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const label = `${o.firstName} ${o.lastName} (register: ${o.id})`
            return { value: o.id, label: label }
          })
        }
      ]
    },
    {
      id: 2,
      name: 'vet',
      activeName: 'vetting',
      historyName: 'vettingHistory',
      label: 'Vetting',
      icon: 'note',
      fields: [
        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'vetting.vettingDate',
          //hintText: 'Select Date',
          label: 'Garda Vetting Date',
          disabled: !add && (disabled || activeFormName !== 'vet'),
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          onChange: (e, v) => {
            change(
              formName,
              'vetting.gardaExpiryDate',
              calculateFrequencyDate(
                v,
                formValues &&
                  formValues.vetting &&
                  formValues.vetting.gardaValidity
              )
            )
            change(
              formName,
              'vetting.vettingFlag',
              calculateFlag(
                calculateFrequencyDate(
                  v,
                  formValues &&
                    formValues.vetting &&
                    formValues.vetting.gardaValidity
                )
              )
            )
          },
          validate: v =>
            activeFormName !== 'vet' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'vetting.vettingOnFile',
          label: 'Garda Vetting on File?',
          disabled: !add && (disabled || activeFormName !== 'vet'),
          required: showAsterix,
          validate: v =>
            activeFormName !== 'vet' && !add
              ? undefined
              : v ? undefined : 'Field is required',
          options: decision.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'vetting.gardaValidity',
          label: 'Current Garda Vetting Validity Perdiod',
          disabled: !add && (disabled || activeFormName !== 'vet'),
          required: showAsterix,
          onChange: (e, v) => {
            change(
              formName,
              'vetting.gardaExpiryDate',
              calculateFrequencyDate(
                formValues &&
                  formValues.vetting &&
                  formValues.vetting.vettingDate,
                v
              )
            )
            change(
              formName,
              'vetting.vettingFlag',
              calculateFlag(
                calculateFrequencyDate(
                  formValues &&
                    formValues.vetting &&
                    formValues.vetting.vettingDate,
                  formValues &&
                    formValues.vetting &&
                    formValues.vetting.gardaValidity
                )
              )
            )
          },
          validate: v =>
            activeFormName !== 'vet' && !add
              ? undefined
              : v ? undefined : 'Field is required',
          options: trainingFrequency.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'vetting.gardaExpiryDate',
          label: 'Garda Vetting Expiry Date',
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          disabled: true,
          component: v => (
            <MuiDatePicker
              textFieldStyle={{
                width: 'calc(100%)',
                ...styles.fieldText
              }}
              floatingLabelStyle={{ ...styles.floatingLabel }}
              disabled={true}
              input={{
                value: calculateFrequencyDate(
                  formValues &&
                    formValues.vetting &&
                    formValues.vetting.vettingDate,
                  formValues &&
                    formValues.vetting &&
                    formValues.vetting.gardaValidity
                )
              }}
              dateFormat={DATE_FORMAT}
              label={'Garda Vetting Expiry Date'}
            />
          )
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          disabled: true,
          component: v => (
            <MuiTextfield
              style={styles.fieldText}
              disabled={true}
              input={{
                floatingLabelStyle: { ...styles.floatingLabel }
              }}
              value={calculateFlag(
                calculateFrequencyDate(
                  formValues &&
                    formValues.vetting &&
                    formValues.vetting.vettingDate,
                  formValues &&
                    formValues.vetting &&
                    formValues.vetting.gardaValidity
                )
              )}
              label={'Garda Vetting Flag'}
            />
          ),
          name: 'vetting.vettingFlag',
          label: 'Garda Vetting Flag'
        },

        //#####################
        //POLICE INTERNATIONAL
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'vetting.vettingCountry',
          label: 'International Police Vetting Country(s)',
          disabled: !add && (disabled || activeFormName !== 'vet'),
          required: showAsterix,
          validate: v =>
            activeFormName !== 'vet' && !add
              ? undefined
              : v ? undefined : 'Field is required',
          options: nationalities.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'vetting.policeVettingDate',
          //hintText: 'Select Date',
          label: 'International Police Vetting Date(s)',
          disabled: !add && (disabled || activeFormName !== 'vet'),
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          validate: v =>
            activeFormName !== 'vet' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'vetting.reportOnFile',
          label: 'International Police Vetting Report(s) on File? ',
          disabled: !add && (disabled || activeFormName !== 'vet'),
          required: showAsterix,
          validate: v =>
            activeFormName !== 'vet' && !add
              ? undefined
              : v ? undefined : 'Field is required',
          options: decision.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        }
      ]
    },
    {
      id: 3,
      name: 'qua',
      activeName: 'qualification',
      historyName: 'qualificationHistory',
      label: 'Qualification',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'qualification.type',
          label: 'Professional Qualification Type(s)',
          disabled: !add && (disabled || activeFormName !== 'qua'),
          required: showAsterix,
          validate: v =>
            activeFormName !== 'qua' && !add
              ? undefined
              : v ? undefined : 'Field is required',
          options: availableValues.qualificationTypes
            .filter(f => f.id > 0)
            .map(o => {
              return { value: o.id, label: o.label }
            })
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          name: 'qualification.title',
          label: 'Qualification Title(s)',
          disabled: !add && (disabled || activeFormName !== 'qua'),
          normalize: v => {
            const val = keepInLength(v, 50)
            return val
          },
          validate: v =>
            activeFormName !== 'qua' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          name: 'qualification.awarding',
          label: 'Awarding University / College(s)',
          disabled: !add && (disabled || activeFormName !== 'qua'),
          normalize: v => {
            const val = keepInLength(v, 50)
            return val
          },
          validate: v =>
            activeFormName !== 'qua' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'qualification.date',
          //hintText: 'Select Date',
          label: 'Qualification Date(s)',
          disabled: !add && (disabled || activeFormName !== 'qua'),
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          validate: v =>
            activeFormName !== 'qua' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'qualification.transcriptsOnFile',
          label: 'Qualification Transcripts(s) on File?',
          disabled: !add && (disabled || activeFormName !== 'qua'),
          required: showAsterix,
          validate: v =>
            activeFormName !== 'qua' && !add
              ? undefined
              : v ? undefined : 'Field is required',
          options: decision.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        }
      ]
    },
    {
      id: 4,
      name: 'pre',
      activeName: 'registration',
      historyName: 'registrationHistory',
      label: 'Professional Registration',
      icon: 'note',
      fields: [
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          name: 'registration.body',
          label: 'Professional Registration Body Name',
          disabled: !add && (disabled || activeFormName !== 'pre'),
          normalize: v => {
            const val = keepInLength(v, 50)
            return val
          },
          validate: v =>
            activeFormName !== 'pre' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          name: 'registration.no',
          label: 'Professional Registration No.',
          disabled: !add && (disabled || activeFormName !== 'pre'),
          normalize: v => {
            const val = keepInLength(v, 10)
            return val
          },
          validate: v =>
            activeFormName !== 'pre' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registration.date',
          //hintText: 'Select Date',
          label: 'Professional Registration Date',
          disabled: !add && (disabled || activeFormName !== 'pre'),
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          validate: v =>
            activeFormName !== 'pre' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registration.expiryDate',
          //hintText: 'Select Date',
          label: 'Professional Registration Expiry Date',
          disabled: !add && (disabled || activeFormName !== 'pre'),
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          validate: v =>
            activeFormName !== 'pre' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          disabled: true,
          component: v => (
            <MuiTextfield
              style={styles.fieldText}
              disabled={true}
              input={{
                floatingLabelStyle: { ...styles.floatingLabel }
              }}
              value={calculateFlag(
                formValues &&
                  formValues.registration &&
                  formValues.registration.date,
                formValues &&
                  formValues.registration &&
                  formValues.registration.expiryDate
              )}
              label={'Professional Registration Flag'}
            />
          ),
          name: 'registration.flag',
          label: 'Professional Registration Flag'
        }
      ]
    },
    {
      id: 5,
      name: 'cvi',
      activeName: 'cv',
      historyName: 'cvHistory',
      label: 'Curriculum Vitae',
      icon: 'note',
      fields: [
        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'cv.date',
          //hintText: 'Select Date',
          label: 'Curriculum Vitae Date',
          disabled: !add && (disabled || activeFormName !== 'cvi'),
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          validate: v =>
            activeFormName !== 'cvi' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'cv.checkedDate',
          //hintText: 'Select Date',
          label: 'Curriculum Vitae Checked Date',
          disabled: !add && (disabled || activeFormName !== 'cvi'),
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          validate: v =>
            activeFormName !== 'cvi' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },

        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'cv.checkByName',
            // disabled: !add,
            label: 'Curriculum Vitae Check By Name',
            disabled: !add && (disabled || activeFormName !== 'cvi'),
            required: showAsterix,
            validate: v =>
              activeFormName !== 'cvi' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.register.filter(f => f.id > 0).map(o => {
              const label = `${o.firstName} ${o.lastName} (register: ${o.id})`
              return { value: o.id, label: label }
            })
          },
          {
            //AUTO POPULATE BASED ON SELECTED NAME
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'cv.theirRole',
            label: 'Their Role',
            disabled: true,
            required: showAsterix,
            // validate: v =>
            // activeFormName !== 'cvi' && !add
            //   ? undefined
            //   : v ? undefined : 'Field is required',
            options: theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],

        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'cv.cvOnFile',
          label: 'Curriculum Vitae on File?',
          disabled: !add && (disabled || activeFormName !== 'cvi'),
          required: showAsterix,
          validate: v =>
            activeFormName !== 'cvi' && !add
              ? undefined
              : v ? undefined : 'Field is required',
          options: decision.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        }
      ]
    },
    {
      id: 6,
      name: 'ref',
      activeName: 'reference',
      historyName: 'referenceHistory',
      label: 'Reference',
      icon: 'note',
      fields: [
        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'reference.date',
          //hintText: 'Select Date',
          label: 'Reference Date',
          disabled: !add && (disabled || activeFormName !== 'ref'),
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          validate: v =>
            activeFormName !== 'ref' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'reference.checkedDate',
          //hintText: 'Select Date',
          label: 'Reference Checked Date',
          disabled: !add && (disabled || activeFormName !== 'ref'),
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          validate: v =>
            activeFormName !== 'ref' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },

        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'reference.checkByName',
            // disabled: !add,
            label: 'Reference Check By Name',
            disabled: !add && (disabled || activeFormName !== 'ref'),
            required: showAsterix,
            validate: v =>
              activeFormName !== 'ref' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.register.filter(f => f.id > 0).map(o => {
              const label = `${o.firstName} ${o.lastName} (register: ${o.id})`
              return { value: o.id, label: label }
            })
          },
          {
            //AUTO POPULATE BASED ON SELECTED NAME
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'reference.theirRole',
            label: 'Their Role',
            disabled: true,
            required: showAsterix,
            validate: v =>
              activeFormName !== 'ref' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],

        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'reference.onFile',
          label: 'Reference on File?',
          disabled: !add && (disabled || activeFormName !== 'ref'),
          required: showAsterix,
          validate: v =>
            activeFormName !== 'ref' && !add
              ? undefined
              : v ? undefined : 'Field is required',
          options: decision.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        }
      ]
    },
    {
      id: 7,
      name: 'dri',
      activeName: 'drive',
      historyName: 'driveHistory',
      label: 'Driving',
      icon: 'note',
      fields: [
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'drive.number',
            label: 'Driving License Number',
            disabled: !add && (disabled || activeFormName !== 'dri'),
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v =>
              activeFormName !== 'dri' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'drive.endorsements',
            label: 'Endorsements?',
            disabled: !add && (disabled || activeFormName !== 'dri'),
            required: showAsterix,
            validate: v =>
              activeFormName !== 'dri' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'drive.points',
            label: 'No. of Penalty Points',
            disabled: !add && (disabled || activeFormName !== 'dri'),
            normalize: v => {
              const val = keepInLength(v, 4)
              return val
            },
            validate: v =>
              activeFormName !== 'dri' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          }
        ],
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'drive.licenseOnFile',
            label: 'Driving Licence on File?',
            disabled: !add && (disabled || activeFormName !== 'dri'),
            required: showAsterix,
            validate: v =>
              activeFormName !== 'dri' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'drive.approvedToOwnCar',
            label: 'Approved to Drive Own Car?',
            disabled: !add && (disabled || activeFormName !== 'dri'),
            required: showAsterix,
            validate: v =>
              activeFormName !== 'dri' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'drive.indemnityOnFile',
            label: 'Own Car Insurance incl. Indemnity on File?',
            disabled: !add && (disabled || activeFormName !== 'dri'),
            required: showAsterix,
            validate: v =>
              activeFormName !== 'dri' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'drive.nctOnFile',
            label: 'Own Car NCT on File?',
            disabled: !add && (disabled || activeFormName !== 'dri'),
            required: showAsterix,
            validate: v =>
              activeFormName !== 'dri' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'drive.approvedToCarCompany',
            label: 'Approved to Drive Company car? ',
            disabled: !add && (disabled || activeFormName !== 'dri'),
            required: showAsterix,
            validate: v =>
              activeFormName !== 'dri' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],

        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'drive.approvalDate',
          //hintText: 'Select Date',
          label: 'Approval Granted Date',
          disabled: !add && (disabled || activeFormName !== 'dri'),
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          validate: v =>
            activeFormName !== 'dri' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'drive.grantedByName',
            // disabled: !add,
            label: 'Approval Granted by  Name',
            disabled: !add && (disabled || activeFormName !== 'dri'),
            required: showAsterix,
            validate: v =>
              activeFormName !== 'dri' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.register.filter(f => f.id > 0).map(o => {
              const label = `${o.firstName} ${o.lastName} (register: ${o.id})`
              return { value: o.id, label: label }
            })
          },
          {
            //AUTO POPULATE BASED ON SELECTED NAME
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'drive.theirRole',
            label: 'Their Role',
            disabled: true,
            required: showAsterix,
            // validate: v =>
            // activeFormName !== 'dri' && !add
            //   ? undefined
            //   : v ? undefined : 'Field is required',
            options: theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'drive.approvalReviewDate',
          //hintText: 'Select Date',
          label: 'Driving Approval Review Date',
          disabled: !add && (disabled || activeFormName !== 'dri'),
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          onChange: (e, v) => {
            change(formName, 'drive.flag', calculateFlag(v))
          },
          validate: v =>
            activeFormName !== 'dri' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          disabled: true,
          component: v => (
            <MuiTextfield
              style={styles.fieldText}
              disabled={true}
              input={{
                floatingLabelStyle: { ...styles.floatingLabel }
              }}
              value={calculateFlag(
                formValues &&
                  formValues.drive &&
                  formValues.drive.approvalReviewDate
              )}
              label={'Driving Approval Flag'}
            />
          ),
          name: 'drive.flag',
          label: 'Driving Approval Flag'
        }
      ]
    }
  ]

  return forms
}

export const activeSection = [
  'vetting',
  'qualification',
  'registration',
  'cv',
  'reference',
  'drive'
]

export const errors = [1, 2]

export const defaultNew = {
  vetting: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  qualification: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  registration: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  cv: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  reference: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  drive: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  vettingHistory: [],
  qualificationHistory: [],
  registrationHistory: [],
  cvHistory: [],
  referenceHistory: [],
  driveHistory: []
}

// "vettings": [
//   {
//     "id": 1,
//     "registerId": 1,
//   "vetting": {
//     "vettingDate": "2001-01-01T23:28:56.782Z",
//     "vettingOnFile": 3,
//     "gardaValidity": 3,
//     "expiryDate": "2001-01-01T23:28:56.782Z",
//     "vettingFlag":"amber",
//     "vettingCountry":2,
//     "policeVettingDate":"2001-01-01T23:28:56.782Z",
//     "reportOnFile":2
//   },
//   "drive":{
//     "number":"123",
//     "endorsments": 2,
//     "points":"20",
//     "licenseOnFile": 3,
//     "approvedToOwnCar":2,
//     "indemnityOnFile": 3,
//     "nctOnFile": 3,
//     "approvedToCarCompany":2,
//     "approvalDate": "2001-01-01T23:28:56.782Z",
//     "grantedByName":2,
//     "approvalReviewDate": "2001-01-01T23:28:56.782Z",
//     "flag":"amber"
//   },
//   "reference":{
//     "date": "2001-01-01T23:28:56.782Z",
//     "checkedDate": "2001-01-01T23:28:56.782Z",
//     "checkByName":2,
//     "onFile": 3,
//   },
//   "cv":{
//     "date": "2001-01-01T23:28:56.782Z",
//     "checkedDate": "2001-01-01T23:28:56.782Z",
//     "checkByName":2,
//     "cvOnFile": 3,
//   },
//   "registration":{
//     "body":"body",
//     "no":"123",
//     "date": "2001-01-01T23:28:56.782Z",
//     "expiryDate": "2001-01-01T23:28:56.782Z"
//   },
//   "qualification":{
//     "type": 2,
//     "title": 2,
//     "awarding": 2,
//     "date": "2001-01-01T23:28:56.782Z",
//     "onFile": 3
//   },
//   "vettingHistory": [],
//   "drive":[],
//   "reference":[],
//   "cv":[],
//   "registration":[],
//   "qualification":[]
//   }
// ]



// WEBPACK FOOTER //
// ./src/personnel/configs/vettings.js